import React from "react";

export default function ResumenInteligente({ resumenData }) {
    return (
        <div className="p-4">
            <h2 className="text-lg font-semibold mb-2">Resumen Inteligente</h2>
            <p>Resumen Inteligente (Integracion Chat GPT)</p>
        </div>
    );
} 